import Material from "./Material";
import apiColorMaterialSchema from "../../services/bimVisualizerApi/schema/material/apiColorMaterialSchema";
import MaterialTypeEnum from "../../enums/MaterialTypeEnum";

export default class ColorMaterial extends Material {

    color: string;
    opacity: number;

    constructor(materialId: number, color: string, opacity: number) {
        super(MaterialTypeEnum.ColorMaterial, materialId);
        this.color = color;
        this.opacity = opacity;
    }

    static fromJSON(json: any): ColorMaterial {
        const parsed = apiColorMaterialSchema.parse(json);
        return new ColorMaterial( parsed.id, parsed.color, parsed.opacity);
    }
}